export default {
  email_form: {
    emailAddress: 'Please enter your email address',
    emailAddressValid: 'Please ensure you enter a valid email address',
    notFound: 'broke'
  },
  stp1: {
    mustHaveWorked:
      `Unfortunately, to bring a claim against Boots you must have worked at a Boots store within the last 6 years (if you work in England or Wales, or 5 years if you work in Scotland).`
  },
  stp2: {
    currentlyWorking: `Please tell us if you are currently working at Boots`,
    lessThan:
      `Unfortunately, the solicitors are unable to act for you if you have worked for Boots for less than 2 months. You may wish to seek advice from another solicitor.`,
    startDate:
      `Please tell us when your employment started at Boots (DD/MM/YYYY format)`,
    endDate:
      `Please tell us when your employment ended at Boots (DD/MM/YYYY format)`,
    endDateFuture:
      'Your end date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    startDateFuture:
      'Your start date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    endBeforeStart: 'Your end date cannot be before your start date',
    moreThanSixYears:
      `Unfortunately, to bring a claim against Boots you must have worked at a Boots store within the last 6 years (if you work in England or Wales, or 5 years if you work in Scotland).`
  },
  stp3: {
    postcode: 'Please enter your postcode',
    postcodeValid: 'Please ensure your postcode is correct',
    houseNumName: 'Please provide the house name or number',
    streetRoad: 'Please enter name of the street you live on',
    townCity: 'Please provide your Town/City',
    country: 'Please provide your Country',
    countryValid: 'You must live in England, Scotland or Wales to be included in the claim'
  },
  stp4: {
    title: 'Please select a title',
    firstName: 'Please enter your first name',
    maidenName: 'Please enter your maiden name',
    lastName: 'Please enter your last name',

    emailAddress: 'Please enter your email address',
    emailAddressValid: 'Please ensure you enter a valid email address',

    contactNo: 'Please enter your contact number',
    contactNoValid: 'Please enter a valid contact number',

    dob: 'Please enter your date of birth',
    dobValid: 'You must be at least 18 years old to submit a claim',

    gender: 'Please select the gender that most closely aligns with you',

    nationalInsurance: 'Please enter a valid NI number or leave blank'
  },
  stp5: {
    agree: ''
  },
  util: {
    lettersOnly: 'Please use letters only and no spaces',
    lettersAndSpacesOnly: 'Please use letters only'
  },
  docUpload: {
    type: 'Please select the document type you wish to upload',
    file: 'Please select the document you wish to upload'
  },
  payslip: {
    aq_nationalInsurance: 'Please enter a valid NI number',
    startDate: `Please tell us when your employment started at Boots (DD/MM/YYYY format)`,
    startDateFuture: 'Your start date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    endDate: `Please tell us when your employment ended at Boots (DD/MM/YYYY format)`,
    endDateFuture: 'Your end date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    endBeforeStart: 'Your end date cannot be before your start date',
    aq_dateEnded: 'Please enter a value',
    aq_jobChangedLastSixYears: 'Please select an option'
  },
  questionnaire: {
    aq_employeeNum: 'Please enter a value',
    aq_jobTitle: 'Please enter a value',
    aq_nationalInsurance: 'Please enter a valid NI number',
    startDate: `Please tell us when your employment started at Boots (DD/MM/YYYY format)`,
    startDateFuture: 'Your start date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    endDate: `Please tell us when your employment ended at Boots (DD/MM/YYYY format)`,
    endDateFuture: 'Your end date cannot be in the future. Please contact us at enquiries@payjustice.co.uk',
    endBeforeStart: 'Your end date cannot be before your start date',
    aq_dateEnded: 'Please enter a value',
    aq_jobCode: 'Please enter a value',
    aq_branchName: 'Please enter a value',
    aq_branchNumber: 'Please enter a value',
    aq_branchPostCode: 'Please enter a value',
    aq_hourlyPay: 'Please enter a value',
    aq_hoursPerWeek: 'Please enter a value',
    aq_jobChangedLastSixYears: 'Please select an option'
  }
};